import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'

// Create the RTK Query API slice
export const dataMapperAPI = createApi({
    reducerPath: 'dataMapperAPI', // Our reducer will live here in the store
    baseQuery: getBaseQuery( getBaseUrl() + 'API/v3/Tools'), // The base API path
    tagTypes: ['MapperList', 'Mapper'], // Optional: useful for caching, invalidation
    endpoints: (builder) => ({
        getMapperList: builder.mutation<any, void>({
            query: () => ({
                url: '/DataMappers',
                method: 'GET',
            }),
        }),
        getMapper: builder.mutation<any, { key: string; action: string; data: any[] }>({
            query: ({ key, action, data }) => ({
                url: `/DataMapperActions/${key}`,
                method: 'POST',
                body: { key, action, data },
            }),
        }),
        mapperActions: builder.mutation<any, { key: string; action: string; data: any[] }>({
            query: ({ key, action, data }) => {
                const url = `/DataMapper/${key}/rows`
                const body = { key, action, data }

                if (action === 'Insert') {
                    return { url, method: 'POST', body }
                } else if (action === 'Update') {
                    return { url, method: 'PUT', body }
                } else {
                    return { url, method: 'DELETE', body }
                }
            },
        }),
    }),
})

// Export hooks generated by the API slice
export const { useGetMapperListMutation, useGetMapperMutation, useMapperActionsMutation } =
    dataMapperAPI
